App.controller('ZochWorkersAddCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'zochaWorkersService', '$filter', 'branchService', '$rootScope', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, zochaWorkersService, $filter, branchService, $rootScope, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_workers';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Dodaj użytkownika';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.workers.list';
    $scope.$emit('link', $scope.link);

    $scope.nationality = 'POLISH';

    $scope.data = {
        email: '',
        birthdate: new Date('01/01/2000'),
        citizenshipType: '',
        firstName: '',
        identifier: '',
        identifierType: 'PESEL',
        lastName: '',
    }

    $scope.addUser = function () {
        var vm = this;

        if (!vm.form.$valid) {
            $scope.showPopUp('', 'Uzupełnij wymagane pola', 'Musisz uzupełnić wszystkie wymagane pola oznaczone czerwoną gwiazdką', '');
            document.body.scrollTop = document.documentElement.scrollTop = 80;
            return 0;
        }

        if ($scope.nationality === 'POLISH') {
            if ($filter('isNoAdultFromIdentifier')($scope.data.identifier)) {
                $scope.data.identifier = '';
                $scope.showPopUp('', 'Błędne dane', 'Nie możesz zarejestrować konta dla osoby niepełnoletniej.', '');
                return 0;
            }
        } else {
            if ($filter('isNoAdultFromBirthdate')($scope.data.birthdate)) {
                // $scope.data.birthdate = new Date('01/01/2000');
                $scope.showPopUp('', 'Błędne dane', 'Nie możesz zarejestrować konta dla osoby niepełnoletniej.', '');
                return 0;
            }
        }

        $scope.data.identifierType = ($scope.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
        $scope.data.identifier = ($scope.nationality !== 'POLISH') ? $scope.id : $scope.data.identifier;
        $scope.data.birthdate = ($scope.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($scope.data.birthdate) : $filter('getDateFromIdentifier')($scope.data.identifier);
        $scope.data.citizenshipType = $scope.nationality;
        $scope.data.branch = $scope.selectedItemBranch;

        console.log($scope.data);

        addUser();
    }

    function addUser() {
        zochaWorkersService.register($scope.data).then(function (data) {
            console.log(data);
            if (data.status === 200) {
                $scope.showPopUp('', 'Gratulacje!', 'Na podany adres e-mail wysłaliśmy wiadomość z linkiem, który należy kliknąć, aby potwierdzić rejestrację.', 'Zarządzaj pracownikami', 'root.home.zoch.workers.list');
            } else {
                if (data.data.message === 'DuplicateIdentifierException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Użycie zajętego PESEL/Numer paszportu', content: 'Użytkownik o wskazanym numerze PESEL/Numer paszportu istnieje w systemie. Skontaktuj się z Administratorem.', text: '', target: ''});
                } else if (data.data.message === 'DuplicateEmailException') {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Użytkownik o wskazanym adresie e-mail istnieje w systemie. Skontaktuj się z Administratorem.', text: '', target: ''});
                } else {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Rejestracja nieudana', content: 'Niestety nie udało się zarejestrować konta. Skontaktuj się z administratorem.', text: '', target: ''});
                }
            }
        });
    }

    $scope.showPopUp = function (ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function (data) {

        }, function () {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.$watchGroup(['data.identifier', 'data.birthdate'], function () {
        if ($scope.nationality === 'POLISH') {
            if ($filter('isNoAdultFromIdentifier')($scope.data.identifier)) {
                $scope.data.identifier = '';
                $scope.showPopUp('', 'Błędne dane', 'Nie możesz zarejestrować konta dla osoby niepełnoletniej.', '');
                return 0;
            }
        } else {
            if ($filter('isNoAdultFromBirthdate')($scope.data.birthdate)) {
                // $scope.data.birthdate = new Date('01/01/2000');
                $scope.showPopUp('', 'Błędne dane', 'Nie możesz zarejestrować konta dla osoby niepełnoletniej.', '');
                return 0;
            }
        }
    })

    branchService.dataZochBranchLists().then(function (data) {
        $scope.branch = data.data.data;
        if ($rootScope.CONFIGURATOR.selectFirstBranchAsDefault) {
            $scope.selectedItemBranch = $scope.branch[0];
        }
    });

    // ##### FILTER ##### //
    $scope.querySearchBranch = function (query) {
        var results = query ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
        return results;
    };

    function createFilterForItem(query) {
        var lowercaseQuery = angular.lowercase(query);

        return function filterFn(items) {
            return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
        };
    };
}]);
